import { VStack, VStackTypes } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { SkeletonItemDesktop } from './desktop';
import { SkeletonItemMobile } from './mobile';
import { SkeletonItemTablet } from './tablet';

interface SkeletonItemProps extends VStackTypes.Props {
  itemsCount?: number;
}

export const SkeletonItem: React.FC<SkeletonItemProps> = ({ itemsCount = 1, ...rest }) => {
  const skeleton = useBreakpointValue({
    base: <SkeletonItemMobile />,
    sm: <SkeletonItemTablet />,
    lg: <SkeletonItemDesktop />,
  });

  const data = Array.from({ length: itemsCount }, (_, i) => i);

  return (
    <VStack space="inline.quarck" pb="inset.nano" {...rest}>
      {data.map((item) => (
        <Box key={item.toString()}>{skeleton}</Box>
      ))}
    </VStack>
  );
};
